import React from 'react'
import PropTypes from 'prop-types'
import { Box, Stack, Flex, Container } from '@chakra-ui/react'
import { loadImage } from 'integrations/unsplash'
import dynamic from 'next/dynamic'

const CarouselSectionTitle = dynamic(() => import(/* webpackChunkName: 'CarouselSectionTitle' */ '../../../../../../components/hub-page/views/sections/carousel/components/section-title'))
const CarouselTitle = dynamic(() => import(/* webpackChunkName: 'CarouselTitle' */ '../../../../../../components/hub-page/views/sections/carousel/components/title'))
const CarouselDescription = dynamic(() => import(/* webpackChunkName: 'CarouselDescription' */ '../../../../../../components/hub-page/views/sections/carousel/components/description'))
const CarouselCTA = dynamic(() => import(/* webpackChunkName: 'CarouselCTA' */ '../../../../../../components/hub-page/views/sections/carousel/components/cta'))
const Carousel = dynamic(() => import(/* webpackChunkName: 'CarouselCTA' */ '../../../../../../components/hub-page/views/sections/carousel/components/carousel'))

const CarouselLayoutThree = ({ data, meta, theme, dataTestId }) => {
  return (
    <Box
      bg={theme.backgroundColor}
      px={[1, 4, 8, 16]}
      data-testid={dataTestId}
    >
      <Box bg={theme.backgroundColor} py={8} px={[4, 4, 0, 0]}>
        <Container maxW='container.lg' mx='auto' px={0}>
          <CarouselSectionTitle
            theme={theme}
            meta={meta}
          />
          <Carousel
            theme={theme}
          >
            {data.map((slide, index) => {
              return (
                <Box
                  boxShadow='site'
                  d='flex !important'
                  key={index}
                >
                  <Flex
                    flexWrap='wrap'
                    flexDirection={[
                      'column',
                      'column',
                      'column',
                      'row'
                    ]}
                    w='100%'
                  >
                    <Box
                      alignItems='center'
                      bg={theme.cardBackgroundColor}
                      d='flex'
                      flexDirection='column'
                      justifyContent='center'
                      order={[2, 2, 2, 1]}
                      p={[4, 4, 4, 8]}
                      textAlign='center'
                      height={theme.minHeight}
                      borderTopLeftRadius={['0', '0', '0', 'site']}
                      borderBottomLeftRadius='site'
                      borderBottomRightRadius={['site', 'site', 'site', '0']}
                      w={['100%', '100%', '100%', '40%']}
                    >
                      <Stack spacing={4} w='full'>
                        <Box>
                          <CarouselTitle
                            theme={theme}
                            data={slide}
                          />
                        </Box>
                        <Box>
                          <CarouselDescription
                            theme={theme}
                            data={slide}
                          />
                        </Box>
                        <Box>
                          <CarouselCTA
                            theme={theme}
                            data={slide}
                          />
                        </Box>
                      </Stack>
                    </Box>
                    <Box
                      backgroundImage={`url(${loadImage(slide.image, theme.minHeight + (meta.imageSize || 800))})`}
                      backgroundPosition={`${slide.imgFocalX}% ${slide.imgFocalY}%`}
                      backgroundRepeat='no-repeat'
                      backgroundSize='cover'
                      height={theme.minHeight}
                      order={[1, 1, 1, 2]}
                      p={16}
                      borderTopRightRadius='site'
                      borderBottomRightRadius={['0', '0', '0', 'site']}
                      borderTopLeftRadius={['site', 'site', 'site', '0']}
                      w={['100%', '100%', '100%', '60%']}
                      role='img'
                      aria-label={!slide.altText ? '' : slide.altText}
                    />
                  </Flex>
                </Box>
              )
            })}
          </Carousel>
        </Container>
      </Box>
    </Box>
  )
}

CarouselLayoutThree.propTypes = {
  data: PropTypes.array,
  theme: PropTypes.object,
  dataTestId: PropTypes.string.isRequired
}

export default CarouselLayoutThree
